/**
 * TanStack Query hooks for `goal-progress-widget`. Thin wrappers over ./api.
 * Filters are embedded in the query key so list data re-fetches whenever
 * the user switches goal type.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	list,
	goalProgressWidgetQueryKeys,
	type ListGoalProgressWidgetResponse,
	type ListGoalProgressWidgetFilters,
} from "./api";

export function useGoalProgressWidgetQuery(
	filters?: ListGoalProgressWidgetFilters,
): UseQueryResult<ListGoalProgressWidgetResponse, Error> {
	return useQuery({
		queryKey: goalProgressWidgetQueryKeys.list(filters),
		queryFn: () => list(filters),
	});
}

/** Kept for scaffold compatibility — page uses useGoalProgressWidgetQuery. */
export function useGoalProgressWidgetList(): UseQueryResult<
	ListGoalProgressWidgetResponse,
	Error
> {
	return useGoalProgressWidgetQuery();
}
